<template>
  <div class="area-handel">
    <div class="areaedit" style="width:720px">
      <div class="box">
        <!-- <h1>操作指南</h1> -->
        <p><strong>修改：</strong>请先选择要操作的地区，在输入框输入地区名或经纬度，然后点击输入框后的修改按钮；</p>
        <p><strong>删除：</strong>请先选择要操作的地区，然后点击下方的删除按钮(如果该地区下有数据则不能删除)；</p>
        <p><strong>创建：</strong>请先选择要操作的地区，在输入框输入地区名和经纬度，然后点击下方的创建按钮；</p>
        <p><strong>经纬度：</strong><a style="color:#409EFF" href="https://lbs.amap.com/console/show/picker" target="_blank" rel="noopener noreferrer">点这里查询</a>（例：104.066143,30.573095）</p>
      </div>
      <el-form :model="form" ref="form" label-width="75px" :rules="rules" >
        <el-form-item label="地区：">
          <el-select v-model="placeData[0]" :disabled="dis[0]" clearable @change="remoteMethod($event, 1)" placeholder="省">
            <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select v-model="placeData[1]" :disabled="dis[1]" clearable @change="remoteMethod($event, 2)" placeholder="市">
            <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select v-model="placeData[2]" :disabled="dis[2]" clearable @change="remoteMethod($event, 3)" placeholder="县">
            <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select style="margin:10px 0 0 0" v-model="placeData[3]" :disabled="dis[3]" clearable @change="remoteMethod($event, 4)" placeholder="镇">
            <el-option v-for="o in town" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
          <el-select style="margin-top:10px" v-model="placeData[4]" :disabled="dis[4]" clearable @change="remoteMethod($event, 5)" placeholder="村">
            <el-option v-for="o in village" :key="o.id" :label="o.name" :value="o.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区名：" prop="name">
          <div class="area-input">
            <el-input type="text" v-model="form.name"></el-input>
            <el-button type="primary" @click="submit('name')">修 改</el-button>
          </div>
        </el-form-item>
        <el-form-item label="经纬度：" prop="lnglat">
          <div class="area-input">
            <el-input type="text" v-model="form.lnglat"></el-input>
            <el-button type="primary" @click="submit('lng')">修 改</el-button>
          </div>
        </el-form-item>
        <!-- <el-form-item label="创建地区：" prop="lnglat">
          <div class="area-input">
            <el-input type="text" v-model="form.newArea"></el-input>
            <el-button type="primary" @click="submit('create')">创 建</el-button>
          </div>
        </el-form-item> -->
        <el-form-item label="">
          <div style="text-align:center" v-show="!comAdminInfo">
            <el-button type="primary" @click="submit('create')">创 建</el-button>
            <el-button type="danger" style="margin-left:30px" @click="open()">删 除</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import mixin_area from '@/Mixins/mixin_area'
export default {
  mixins: [ mixin_area ],
  data() {
    return {
      form: {
        name: '',
        lnglat: '',
        newArea: '',
      },
      province: [],
      city: [],
      county: [],
      town: [],
      village: [],
      dis: [],
      placeData:[],
      comAdminInfo: false,
      admin: false,
      rules: {
        // name: [{ required: true, message: '请输入地区名', trigger: 'blur' }],
        // lnglat: [{ required: true, message: '请输入地区经纬度', trigger: 'blur' }],
      },
    }
  },
  methods:{
    resetForm() {
      this.$refs.form.resetFields()
      this.placeData[0] = this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''
      this.admin ?  '' : (this.dis = [],this.getDefault());
    },
    submit(str) {
      let vm = this
      //过滤空字符串
      let place = vm.placeData.filter(x => x)
      // console.log(place);
      
      if (str === 'name') {
        if (place.length === 0) {
          return vm.$message.info('请至少选择一个地区')
        } else if (vm.form.name == '') {
          // console.log(place);
          return vm.$message.info('请输入地区名')
        } else {
          vm.$api.changeArea(place[place.length-1],vm.form.name).then(res => {
            if (res.data.status === 0) {
              vm.resetForm()
              vm.$message.success('修改成功')
            } else{
              this._status(res.data)
            }
          })
        }
      } else if (str === 'lng') {
        if (place.length === 0) {
          return vm.$message.info('请至少选择一个地区')
        } else if (vm.form.lnglat == '') {
          // console.log(place);
          return vm.$message.info('请输入地区经纬度')
        } else {
          vm.$api.changeAreaLng(place[place.length-1],vm.form.lnglat).then(res => {
            if (res.data.status === 0) {
              vm.resetForm()
              vm.$message.success('修改成功')
            } else{
              this._status(res.data)
            }
          })
        }
      } else {
        if (place.length === 0) {
          return vm.$message.info('请至少选择一个地区')
        } else if (vm.form.name == '') {
          // console.log(place);
          return vm.$message.info('请输入地区名')
        } else if (vm.form.lnglat == '') {
          // console.log(place);
          return vm.$message.info('请输入地区经纬度')
        } else {
          vm.$api.createArea(place[place.length - 1],vm.form.name).then(res => {
            if (res.data.status === 0) {
              // vm.resetForm()
              vm.$api.changeAreaLng(res.data.data,vm.form.lnglat).then(res => {
                if (res.data.status === 0) {
                  vm.resetForm()
                  // this.admin ? vm.resetForm() : '';
                  vm.$message.success('创建成功')
                } else if (res.data.status === 10) {
                  vm.$message.error('权限不够')
                } else {
                  vm.$message.error('创建失败')
                }
              })
            } else{
              this._status(res.data)
            }
          })
        }
      }
    },
    //删除
    open() {
      let vm = this
      let place = vm.placeData.filter(x => x)
      
      if (place.length === 0) {
        return vm.$message.info('请至少选择一个地区')
      } else {
        this.$confirm('此操作将永久删除该地区, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          vm.$api.deleteAreaLng(place[place.length - 1]).then(res => {
            if (res.data.status === 0) {
              vm.resetForm()
              vm.$message.success('删除成功')
            } else if (res.data.status === 13) {
              vm.$message.error('删除失败,该地区数据不为空')
            } else {
              vm.$message.error('删除失败')
            }
          })
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
      }
    },
    //设置默认地址
    getDefault() {
      let vm = this
      if (this.userInfo.admin) {
        for (let i = 0; i < 5; i++) { vm.dis.push(false) }
      } else {
        vm.$api.getFather({ areaId: this.userInfo.areaId }).then(res => {
          if (res.data.status === 0) {  
            let response = JSON.parse(res.data.data)
            // console.log(response);
            response.forEach((o, i) => {
              this.areaGet({ value: { areaId: o.id }, key: i + 1 })
              // vm.placeData.push({areaId:o.id})
              i === 5?vm.dis.push(false):vm.dis.push(true)
              switch(o.level) {
                case 0: vm.placeData[0]= o.id; break
                case 1: vm.placeData[1]= o.id; break
                case 2: vm.placeData[2]= o.id; break
                case 3: vm.placeData[3]= o.id; break
                case 4: vm.placeData[4]= o.id; break
              }
            })
              // console.log(vm.placeData);
          } else {
            this._status(res.data)
          }
        })
      }
    },
    getAreaInfo(areaId) {
      this.$api.getPlaceName({ areaId }).then(res => {
        if (res.data.status === 0) {
          // console.log(res.data.data);
          let data = JSON.parse(res.data.data)
          data.level == '4' ? this.comAdminInfo = true:false
        } else{
          this._status(res.data)
        }
        
      })
    }
  },
  created() {
    this.areaGet({ value: { areaId: 0 }, key: 0 })
    this.admin = this.userInfo.admin
    this.admin ? '' : (this.getDefault(), this.getAreaInfo(this.userInfo.areaId))
  }
}
</script>

<style scoped>
.area-handel .areaedit{
  display: flex;justify-content: center;align-items: center;flex-direction: column;
  position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);
}
.area-input{display: flex;justify-content: space-between;}
.area-input .el-input{width: 80%;}

.box{margin: 30px 0;}
.box p{line-height: 30px;}
</style>